export const uiLock = {
  _timeoutId: null as number | null,

  enable() {
    if (document.getElementById('__ui_lock_blocker__')) return;

    const blocker = Object.assign(document.createElement('div'), {
      id: '__ui_lock_blocker__',
      style: Object.assign(document.createElement('div').style, {
        position: 'fixed',
        inset: '0',
        zIndex: '2147483647',
        background: 'transparent',
        pointerEvents: 'all',
        cursor: 'default',
      }),
    });

    document.body.appendChild(blocker);

    this._timeoutId = window.setTimeout(() => {
      if (document.getElementById('__ui_lock_blocker__'))
        blocker.style.cursor = 'progress';
      this._timeoutId = null;
    }, 750);
  },

  disable() {
    if (this._timeoutId) clearTimeout(this._timeoutId);
    this._timeoutId = null;

    document.getElementById('__ui_lock_blocker__')?.remove();
  },
};
